import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TemplateUploadService } from 'src/app/core/services/template-upload.service';
import { Subscription } from 'rxjs';
import { UPLOAD_STATUS } from 'src/app/core/enums/uploadStatus.enum';
import { HttpEvent, HttpEventType, HttpProgressEvent, HttpResponse } from '@angular/common/http';
import { FILE_EVENT_TYPE_ENUM, FILE_EXTENSIONS, FILE_TYPE } from 'src/app/core/enums/file.enum';
import { ConstantsUtil } from 'src/app/core/utils/constants.util';
import { ERROR_TYPE_ENUM } from 'src/app/core/enums/errorType.enum';
import { UNITS_ENUM } from 'src/app/core/enums/units.enum';
import { ThemeSwitchService } from 'src/app/core/services/theme/theme-switch.service';
import { Theme } from 'src/app/core/models/Theme.enum';

@Component({
	selector: 'app-upload-template-popup',
	templateUrl: './upload-template-popup.component.html',
	styleUrls: ['./upload-template-popup.component.scss']
})
export class UploadTemplatePopupComponent implements OnInit {

	private readonly fileEventType = { ...FILE_EVENT_TYPE_ENUM };
	private readonly fileType = { ...FILE_TYPE };
	public fileExtensions = { ...FILE_EXTENSIONS };
	public errorType = { ...ERROR_TYPE_ENUM };
	private readonly units = { ...UNITS_ENUM }
	public fileTypeErrorMessage: string;
	public fileExtension: string;
	public sheetJsExcelName: File;
	public fileName: string;
	public uploadButtonEnabled: boolean = false;
	public uploadStatus;
	public uploadStatusEnum;
	public isExcelDrop: boolean;
	public sheetBufferRender;
	public errorDetails: { message: string, type: string };
	public fileNameAfterUpload: string;
	public progress: number = 0;
	public enableFinishButton: boolean = false;
	private $uploadTemplateSubscription: Subscription;
	private $processTemplateSubscription: Subscription;
	private readonly supportedFileTypes: string[] = [this.fileType.XLSX.toString(), this.fileType.XLSM.toString(), this.fileType.CSV.toString()]
	public errorMessageType;
	startTime: any;
	endTime: any;
	currTime: any;
	prevTime: any = 0;
	speed: number = 0;
	bytesReceied: number = 0;
	oldbytes: number = 0;
	unit: string = this.units.Mb;
	@Input() assetType;
	@Input() plant;
	@Input() folderName;
	@Input() plantId;
	constructor(public modalRef: BsModalRef, public templateUploadService: TemplateUploadService, private themeSwitchService: ThemeSwitchService) {
		this.uploadStatusEnum = UPLOAD_STATUS;
	}

	public ngOnInit(): void {
		// prevent dropping of file outside allowed area
		window.addEventListener(ConstantsUtil.events.DRAG_OVER, function (e) {
			e.preventDefault();
		}, false);
		window.addEventListener(this.fileEventType.drop, function (e) {
			e.preventDefault();
		}, false);
	}

	// close template upload popup
	public onCloseButtonClick(): void {
		this.modalRef.hide();
	}

	// cancel subscription on click of cancel button
	public onCancelButtonClick(): void {
		if (this.$uploadTemplateSubscription) {
			this.$processTemplateSubscription.unsubscribe();
		}
		this.modalRef.hide();
	}

	// close template upload popup on clicking Finish button
	public onFinishButtonClick(): void {
		this.modalRef.hide();
	}

	// call uplloadFile function to start uploading template
	public onStartUploadButtonClick(): void {
		this.uploadFile();
	}

	// select file to upload
	public selectFile(event: Event | DragEvent): void {
		if (this.uploadStatus !== this.uploadStatusEnum.started && this.uploadStatus !== this.uploadStatusEnum.completed) {
			this.enableFinishButton = false;
			this.fileExtension = null;
			this.fileTypeErrorMessage = null;
			this.errorDetails = { message: null, type: null };
			this.uploadStatus = UPLOAD_STATUS.not_started;
			const target = (event.type == this.fileEventType.change ? event.target : event['dataTransfer'].files);
			this.throwErrorsOnNoFileSelected(event, target);
			this.sheetJsExcelName = (event.type == this.fileEventType.change ? target.files[0] : target[0]);
			this.fileName = (event.type == this.fileEventType.change ? target.files[0].name : target[0].name);
			this.fileExtension = this.fileName.split('?')[0].split('.').pop();
			if (this.fileExtension) {
				this.uploadButtonEnabled = true;
			}
			this.enableUploadButtonOrDisplayErrorMessages(event, target);
		}
	}

	/**
	 * 
	 * @param event - file selection events 
	 * @param target - file event target
	 */
	private throwErrorsOnNoFileSelected(event: Event | DragEvent, target): void {
		if (event.type == this.fileEventType.drop && target.length === 0) {
			throw new Error(ConstantsUtil.errorMessages.ERROR);
		}
		if (event.type == this.fileEventType.change && target.files.length === 0) {
			throw new Error(ConstantsUtil.errorMessages.ERROR);
		}
		if (event.type == this.fileEventType.change && target.files.length > 1) {
			throw new Error(ConstantsUtil.errorMessages.CANNOT_USE_MULTIPLE_FILES);
		}
	}

	/**
	 * 
	 * @param target - file event target
	 * @param target - file event target
	 */
	private enableUploadButtonOrDisplayErrorMessages(event: Event | DragEvent, target) {
		if (this.supportedFileTypes.includes(this.fileExtension)) {
			//checks for selected file name and plant name dropbox 
			if (this.compareString(this.fileName.split('?')[0].split('.')[0], this.folderName)) {
				this.uploadButtonEnabled = true;
				const reader: FileReader = new FileReader();
				reader.readAsArrayBuffer((event.type == this.fileEventType.change ? target.files[0] : target[0]));
				this.sheetBufferRender = (event.type == this.fileEventType.change ? target.files[0] : target[0]);
				this.isExcelDrop = true;
			} else {
				this.uploadButtonEnabled = false;
				this.uploadStatus = UPLOAD_STATUS.failed;
				this.errorDetails = { message: `${ConstantsUtil.errorMessages.INCORRECT_FILE_UPLOADED_PLEASE_RENAME_THE_FILE_TO_THIS_FORMAT} "${this.folderName}"`, type: this.errorType.serverError };
				this.errorMessageType = typeof this.errorDetails.message;
			}
		}
		else if (this.fileExtension && !(this.supportedFileTypes.includes(this.fileExtension))) {
			this.errorDetails = { message: ConstantsUtil.errorMessages.ONLY_XLSM_XLSX_AND_CSV_IS_SUPPORTED, type: this.errorType.clientSideError };
		}
		else if (!this.fileExtension && this.fileName == '') {
			this.errorDetails = { message: ConstantsUtil.errorMessages.EMPTY_PLEASE_CHOOSE_A_FILE, type: this.errorType.clientSideError };
			this.fileName = null;
		}
	}

	// start uploading selected file
	public uploadFile(): void {
		// console.log(this.fileName.split('?')[0].split('.')[0].localeCompare(this.folderName))
		if (this.compareString(this.fileName.split('?')[0].split('.')[0], this.folderName)) {
			this.uploadStatus = UPLOAD_STATUS.started;
			this.speed = 0;
			this.progress = 0;
			this.checkFileUpload();
		} else {
			this.uploadButtonEnabled = false;
			this.uploadStatus = UPLOAD_STATUS.failed;
			this.errorDetails = { message: `${ConstantsUtil.errorMessages.INCORRECT_FILE_UPLOADED_PLEASE_RENAME_THE_FILE_TO_THIS_FORMAT} "${this.folderName}"`, type: this.errorType.serverError };
			this.errorMessageType = typeof this.errorDetails.message
		}
	}

	/**
	 * check file upload and display error message if failed
	 */
	private checkFileUpload() {
		if (!this.errorDetails.message && this.fileExtension) {
			this.errorDetails = { message: null, type: null };
			this.fileNameAfterUpload = null;
			let request = this.sheetJsExcelName;
			this.uploadButtonEnabled = false;
			this.callUploadFile(request);
		} else {
			this.uploadStatus = UPLOAD_STATUS.failed;
			if (!this.fileExtension) {
				this.errorDetails = { message: ConstantsUtil.errorMessages.EMPTY_PLEASE_CHOOSE_A_FILE, type: this.errorType.clientSideError };
				this.fileName = null;
				this.errorMessageType = typeof this.errorDetails.message;
			}
			else {
				this.errorDetails = { message: this.fileTypeErrorMessage, type: this.errorType.clientSideError };
				this.errorMessageType = typeof this.errorDetails.message;
			}
		}
	}

	/**
	 * call upload file method
	 * @param request - File selected
	 */
	private callUploadFile(request: File) {
		this.$uploadTemplateSubscription = this.templateUploadService.uploadFile(request).subscribe({
			next: (event: HttpEvent<any>) => {
				switch (event.type) {
					case HttpEventType.Sent:
						this.uplaodFileHttpSent();
						break;
					case HttpEventType.UploadProgress:
						this.uploadFileUploadProgress(event);
						break;
					case HttpEventType.Response:
						this.uploadFileResponse(event, request);
				}
			}, error: (error) => {
				this.uploadStatus = UPLOAD_STATUS.failed;
				this.progress = 0;
				this.errorDetails = { message: error?.error.message, type: this.errorType.serverError }
				this.errorMessageType = typeof this.errorDetails.message;
			}
		});
	}

	/**
	 * Http sent event
	 */
	private uplaodFileHttpSent() {
		this.startTime = new Date().getTime();
		this.prevTime = this.startTime;
	}

	/**
	 * Http progress event 
	 * @param event - Progress event
	 */
	private uploadFileUploadProgress(event: HttpProgressEvent) {
		this.progress = Math.round(event.loaded / event.total * 100);
		//tracking percent received and how much time has passed
		this.progress = Math.round((100 * event.loaded) / event.total);
		this.currTime = new Date().getTime();
		//setting start time
		if (this.progress === 0) {
			// if any fucntionality needed on progress start
		}
		//tracking how much data is received
		this.bytesReceied = event.loaded / 1000000;
		//calculating download speed per percent data received
		this.speed =
			+((this.bytesReceied - this.oldbytes) /
				((this.currTime - this.prevTime) / 1000)).toFixed(2);
		if (this.speed < 1) {
			this.unit = this.units.Kb;
			this.speed *= 1000;
		} else this.unit = this.units.Mb;
		//updating previous values
		this.prevTime = this.currTime;
		this.oldbytes = this.bytesReceied;
		//calculating avg download speed
		this.checkFor100PercentProgress(event);
	}

	/**
	 * check 100% progress
	 * @param event - Http progress event
	 */
	private checkFor100PercentProgress(event: HttpProgressEvent) {
		if (this.progress === 100) {
			this.endTime = new Date().getTime();
			let duration = (this.endTime - this.startTime) / 1000;
			let mbps = event.total / duration / 1000000;
			if (mbps < 1) {
				this.speed = +(event.total / duration / 1000).toFixed(2);
				this.unit = this.units.Kb;
			} else {
				this.speed = +mbps.toFixed(2);
				this.unit = this.units.Mb;
			}
		}
	}

	/**
	 * 
	 * @param event - Http response
	 * @param request - File
	 */
	private uploadFileResponse(event: HttpResponse<any>, request: File) {
		this.fileNameAfterUpload = event['file_name'];
		this.uploadButtonEnabled = false;
		this.uploadStatus = UPLOAD_STATUS.completed;
		this.$processTemplateSubscription = this.templateUploadService.processFile(event.body['path'], this.assetType, this.plant, this.plantId).subscribe({
			next: () => {
				this.uploadStatus = UPLOAD_STATUS.processed;
				this.enableFinishButton = true;
				this.templateUploadService.uploadDetail$.next(request);
			},
			error: (error) => {
				this.uploadStatus = this.uploadStatusEnum.failed;
				this.errorDetails = { message: error?.error.message, type: this.errorType.serverError }
				this.errorMessageType = typeof this.errorDetails.message;
			}
		});
	}

	// clear selected file value
	public clearValue(event: Event): void {
		event.target['value'] = null;
	}

	// cancel on going template upload
	public onCancelProgress(): void {
		this.fileExtension = null;
		this.uploadStatus = UPLOAD_STATUS.not_started;
		this.progress = 0;
		this.fileName = null;
		this.sheetJsExcelName = null;
		if (this.$uploadTemplateSubscription) {
			this.$uploadTemplateSubscription.unsubscribe();
		}
		if (this.$processTemplateSubscription) {
			this.$processTemplateSubscription.unsubscribe();
		}
	}

	// retry file template upload
	public retryUpload(): void {
		this.errorDetails = { message: null, type: null }
		this.uploadFile();
	}

	public compareString(firstString, secondString): boolean {
		return typeof firstString === 'string' && typeof secondString === 'string'
			? firstString.localeCompare(secondString, undefined, { sensitivity: 'accent' }) === 0
			: firstString === secondString;
	}

	/**
	 * get upload image
	 */
	public get uploadIconImage() {
		return this.themeSwitchService.getTheme() === Theme.DARK ? 'assets/upload-icon.svg' : 'assets/upload-icon-light-theme.svg';
	}

	/**
	 * get close image
	 */
	public get closeImage() {
		return this.themeSwitchService.getTheme() === Theme.DARK ? 'close.svg' : 'close-light-theme.svg';
	}

	/**
	 * get retry image
	 */
	public get retryImage() {
		return this.themeSwitchService.getTheme() === Theme.DARK ? 'retry-icon.svg' : 'retry-icon-light-theme.svg';
	}
	/**
	 * get upload image for uploader popup
	 */
	public get uploadIcon(): string {
		const isDark = this.themeSwitchService.getTheme() === Theme.DARK;
		const isDisabled = !this.uploadButtonEnabled || !!this.errorDetails?.message;

		if (isDisabled) {
			return isDark ? 'upload-icon-disabled.svg' : 'upload-icon-light-theme-disabled.svg';
		} else {
			return isDark ? 'upload-icon.svg' : 'upload-icon-light-theme.svg';
		}
	}
}
